import React from 'react';
import { Band } from '../../types/commission';
interface BandBarProps {
  bands: Band[];
  value: number;
  scaleMax: number;
  markerLabel: string;
  /** Discrete counts sit in the middle of their unit; averages sit at their exact value. */
  discrete?: boolean;
  ariaLabel: string;
}
export function BandBar({
  bands,
  value,
  scaleMax,
  markerLabel,
  discrete = false,
  ariaLabel
}: BandBarProps) {
  const current = bands.find(band => value >= band.from && (band.to === null || value < band.to));
  const position = Math.min(98, (discrete ? value + 0.5 : value) / scaleMax * 100);
  return <div role="img" aria-label={ariaLabel} data-id="element-887" data-mp="fd04wr4slh94">
      <div className="relative pt-6" data-id="element-888" data-mp="fdtes0z1smvh">
        <span className="absolute top-0 -translate-x-1/2 whitespace-nowrap rounded bg-sf-blue-dark px-1.5 py-0.5 text-[11px] font-semibold text-white" style={{
        left: `${position}%`
      }} data-id="element-889" data-mp="bb50hdrkenr4">
          {markerLabel}
        </span>
        <div className="flex h-3 overflow-hidden rounded-full" data-id="element-890" data-mp="1mp0h6qy4b4kg">
          {bands.map(band => {
          const width = ((band.to ?? scaleMax) - band.from) / scaleMax * 100;
          return <span key={band.label} style={{
            width: `${width}%`
          }} className={`border-r-2 border-white last:border-r-0 ${band === current ? 'bg-sf-blue' : 'bg-[#E5E5E5]'}`} data-id="element-891" data-mp="kixd9txx3o90" />;
        })}
        </div>
        <span className="absolute bottom-0 h-5 w-0.5 -translate-x-1/2 translate-y-1 bg-sf-blue-dark" style={{
        left: `${position}%`
      }} aria-hidden="true" data-id="element-892" data-mp="tkn4aynw0l69" />
      </div>
      <ol className="mt-2 flex" data-id="element-893" data-mp="3sxp8zclfkyv5">
        {bands.map(band => {
        const width = ((band.to ?? scaleMax) - band.from) / scaleMax * 100;
        const isCurrent = band === current;
        return <li key={band.label} style={{
          width: `${width}%`
        }} className="pr-2" data-id="element-894" data-mp="al96g5n1eqah">
              <span className={`block text-xs ${isCurrent ? 'font-semibold text-sf-text' : 'text-sf-weak'}`} data-id="element-895" data-mp="andm1kuatdql">{band.label}</span>
              <span className={`block text-xs tabular-nums ${isCurrent ? 'font-semibold text-sf-blue-dark' : 'text-sf-weak'}`} data-id="element-896" data-mp="3ea41l6hiwdhf">{band.valueLabel}</span>
            </li>;
      })}
      </ol>
    </div>;
}